// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"30":"7313c8a7","463":"4e1ff559"}[chunkId] + ".chunk.js";
};